module.exports = __webpack_public_path__ + "static/media/ic_share_map.ae796b96.svg";